import React, { useEffect, useState, useRef } from "react";
import { useStyles } from "./TakisSearchBox.styles";
import { useQueryParams } from "../hooks/useLocationData";
import { TakisSvg } from "./TakisSvgs";
import { useHistory } from "react-router-dom";
import { useLanguage, supportedLanguages } from "../hooks/useLanguage";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { useTheme } from "@material-ui/core/styles";

const SearchBox = ({
  searchConfig,
  onSearching
}) => {

  const searchParam = (searchConfig && searchConfig.title) ? searchConfig.title.toLowerCase() : 'search';
  const history = useHistory();
  const classes = useStyles();
  const params = useQueryParams()
  const [isOpen, setIsOpen] = useState(false);
  const paramSearchValue = params.get(searchParam)
  const paramsValue = paramSearchValue !== null ? paramSearchValue : ''
  const language = useLanguage();
  const theme = useTheme();

  const onMobile = useMediaQuery(
    theme.breakpoints.down(theme.breakpoints.values.lg)
  );

  const toggleTitle = language === supportedLanguages.en
      ? 'expand search'
      : 'mostrar búsqueda';
  const toggleTitleOpened = language === supportedLanguages.en
      ? 'search'
      : 'buscar';

  const searchInput = useRef(null);
  const searchToggle = useRef(null);
  const searchContainer = useRef(null);

  // Default is whatever comes from the param search
  const [searchValue, setSearchValue] = useState(()=>{
    return paramsValue
  });

  // Search params effect
  useEffect(()=> {
    params.set(searchParam, searchValue)
  }, [
    params,
    searchParam,
    searchValue
  ])

  const sendSearch = () => {
    const search = {
      pathname: searchConfig.url,
      search: params.toString()
    }
    history.push(search);
    onSearching();
  }

  const toggleSearchBox = () => {
    if (searchValue !== '' && isOpen) {
      sendSearch()
      if(!onMobile) {
        setIsOpen(false)
      }
    } else if (searchValue === '' && isOpen) {
      if(!onMobile) {
        setIsOpen(false)
      }
    } else {
      setIsOpen(true)
      focusOnInput()
    }
  }

  const focusOnInput = () => {
    searchInput.current.focus()
  }

  const animationEnd = (event) => {
    if (event.propertyName === 'max-height' && isOpen) {
      focusOnInput()
    }
  }

  const handleKeyDownOnInput = (event) => {
    // Enter
    if (event.key === 'Enter') {
      sendSearch()
    }
  }

  const escHandler = (event) => {
    // Enter
    if (event.key === 'Escape') {
      searchToggle.current.focus()
      setIsOpen(false)
    }
  }

  const handleKeyDownOnButton = (event) => {

    // handle tab
    if (event.keyCode === 9 && event.shiftKey && isOpen.current && searchValue !== '' ) {
      // move focus to search button
      focusOnInput()
    }
  }
  return (
    <div
      className={classes.toggleSearchBoxContainer}
      ref={searchContainer}
      onKeyDown={escHandler}
      >
      {!onMobile &&
        <button
          className={`
            ${classes.toggleSearchBox}
            ${isOpen ? 'open' : 'closed'}
            ${searchValue !== '' ? 'filled' : 'empty'}
          `}
          aria-controls={"search-input-id"}
          aria-expanded={isOpen}
          // Lands a link Home if no target is found on list from server.
          onClick={toggleSearchBox}
          ref={searchToggle}
          title={`${isOpen ? toggleTitleOpened : toggleTitle}`}
          onKeyDown={handleKeyDownOnButton}
          >
          <TakisSvg
            icon='search'
            svg_class={classes.svg}
            viewbox="search"
            ariaHidden="true"
            />
          <span className="sr-only">{isOpen ? toggleTitleOpened : toggleTitle}</span>
        </button>
      }
      <div
        className={`
          ${classes.searchContainer}
          ${isOpen ? 'open' : 'closed'}
          ${searchValue !== '' ? 'filled' : 'empty'}
        `}
        id={"search-input-id"}
        onTransitionEnd={animationEnd}
        >
        <label
          htmlFor={searchConfig.title}
          style={{top: "0.5em"}}
          className={`
            ${classes.searchLabel}
            ${isOpen ? 'open' : 'closed'}
            ${searchValue !== '' ? 'aside' : 'front'}
          `}
          >
          { searchConfig.label }
        </label>
        <input
          id={searchConfig.title}
          type="text"
          style={{top: "0.5em"}}
          ref={searchInput}
          disabled={!isOpen}
          aria-label="Search"
          className={`
            ${classes.searchInput}
            ${isOpen ? 'open' : 'closed'}
            ${searchValue !== '' ? 'filled' : 'empty'}
          `}
          defaultValue={paramsValue}
          onChange={event => setSearchValue(event.target.value)}
          onKeyDown={handleKeyDownOnInput}
        />
      </div>
      {/* Button mobile position for focus */}
      {onMobile &&
        <button
          className={`
            ${classes.toggleSearchBox}
            ${isOpen ? 'open' : 'closed'}
            ${searchValue !== '' ? 'filled' : 'empty'}
          `}
          aria-controls={"search-input-id"}
          aria-expanded={isOpen}
          // Lands a link Home if no target is found on list from server.
          onClick={toggleSearchBox}
          ref={searchToggle}
          title={`${isOpen ? toggleTitleOpened : toggleTitle}`}
          onKeyDown={handleKeyDownOnButton}
          >
          <TakisSvg
            icon='search'
            svg_class={classes.svg}
            viewbox="search"
            ariaHidden="true"
            />
        </button>
      }
    </div>
  );
};


export default SearchBox;
